export default {
  isItemStale(state, getters, rootState) {
    return (id) => {
      const item = state.items[id];

      return item && rootState.app.connectionStaleSequence != item.staleSequence;
    };
  },
  partners(state) {
    return state.partners;
  },
  featuredPartners(state) {
    return state.featuredPartners;
  }
};
